/**
 * @generated SignedSource<<0c3a2c868cc4e2fa8b4090dc068df3d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type styleArticleContent$data = {
  readonly entityId: string;
  readonly " $fragmentSpreads": FragmentRefs<"articleImageGalleryContent" | "articleMoreOnThisListStyleArticle" | "reduceWhitespaceByAvailableSpaceArticle" | "styleArticleAuthorBlockArticle">;
  readonly " $fragmentType": "styleArticleContent";
};
export type styleArticleContent$key = {
  readonly " $data"?: styleArticleContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"styleArticleContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "styleArticleContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleImageGalleryContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "styleArticleAuthorBlockArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "reduceWhitespaceByAvailableSpaceArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleMoreOnThisListStyleArticle"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "e0a652c1a30546a0773c379cd01d505b";

export default node;
